
























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "OccToast",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    toastText: {
      type: String,
      default: ""
    },
    links: {
      type: Array,
      default: () => {}
    }
  },
  setup(_props, { emit }) {
    const close = () => {
      emit("close");
    };

    return { close };
  }
});
